var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer"},[(_vm.auth.loggedin)?_c('MenuMember',{attrs:{"items":_vm.menu.member,"profile":_vm.profile}}):_c('MenuGuest',{attrs:{"items":_vm.menu.guest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }